import PropTypes from 'prop-types';
import { Button, DateInput } from 'ypf-pas-general-ui-components';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';

import './DateRange.scss';

const DateRange = ({
  finalDate,
  handleAddRange,
  handleSuprRange,
  id,
  index,
  max,
  min,
  onChangeFinalDate,
  onChangeStartDate,
  startDate,
  disableSuprButton,
  disableAddButton
}) => (
  <div className="date-range-container">
    <div className="label">Se aplicará en el periodo:</div>
    <div className="label">
      <b>Desde</b>
    </div>
    <div className="date-input">
      <DateInput
        className="date-input"
        max={max}
        min={min}
        name="startDate"
        onChange={(evt) => onChangeStartDate(evt.target.value, index)}
        value={startDate}
        widthDateInput="100%"
      />
    </div>
    <div className="label">
      <b>Hasta</b>
    </div>
    <div className="date-input">
      <DateInput
        className="date-input"
        max={max}
        min={startDate}
        name="finalDate"
        onChange={(evt) => onChangeFinalDate(evt.target.value, index)}
        value={finalDate}
        widthDateInput="100%"
      />
    </div>
    <div className="button-container">
      <Button
        // className="button"
        colorIcon="primary"
        disabled={disableAddButton}
        icon={AiOutlinePlusCircle}
        onClick={() => {
          handleAddRange(id);
        }}
        sizeIcon="24px"
        type="button"
        variant="light-gray"
        widthButton="40px"
      />
      <Button
        colorIcon="danger"
        disabled={disableSuprButton}
        icon={AiOutlineMinusCircle}
        onClick={() => {
          handleSuprRange(index);
        }}
        sizeIcon="24px"
        type="button"
        variant="light-gray"
        widthButton="40px"
      />
    </div>
  </div>
);

DateRange.propTypes = {
  finalDate: PropTypes.string.isRequired,
  handleAddRange: PropTypes.func.isRequired,
  handleSuprRange: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  max: PropTypes.string.isRequired,
  min: PropTypes.string.isRequired,
  onChangeFinalDate: PropTypes.func.isRequired,
  onChangeStartDate: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  disableSuprButton: PropTypes.bool.isRequired,
  disableAddButton: PropTypes.bool.isRequired
};

export default DateRange;
